export enum TermKeys {
  Whatsapp = "whatsapp1",
  SupportMomentsTutorial = "supportmoments",
}
